import { IColumns } from '../../components/Table'

export enum KycStatus {
  NotInitial = 'NOT INITIAL',
  InProcess = 'IN PROCESS',
  Requested = 'REQUESTED',
  Passed = 'PASSED',
  OnHold = 'ON HOLD',
  Rejected = 'REJECTED',
  Failed = 'FAILED',
}

export type UsersColumnsType =
  | 'id'
  | 'groups'
  | 'email'
  | 'name'
  | 'company'
  | 'kycStatus'
  | 'riskScore'
  | 'role'
  | 'introducer'
  | 'isActive'
  | 'loginAt'

export const columns: IColumns<UsersColumnsType>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  // {
  //   id: 'groups',
  //   label: 'GROUPS',
  // },
  // {
  //   id: 'email',
  //   label: 'EMAIL',
  // },
  {
    id: 'name',
    label: 'NAME',
  },
  {
    id: 'company',
    label: 'COMPANY',
  },
  {
    id: 'kycStatus',
    label: 'KYС STATUS',
    format: (value) =>
      value
        ?.toString()
        .replace('_', ' ')
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
  },
  {
    id: 'riskScore',
    label: 'RISK SCORE',
    format: (value) =>
      value
        ?.toString()
        .replace('_', ' ')
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
  },
  {
    id: 'role',
    label: 'USER TYPE',
    format: (value) =>
      value
        ?.toString()
        .replace('_', ' ')
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
  },
  {
    id: 'introducer',
    label: 'INTRODUCER',
    format: (value) => value || 'N/A',
  },
  // {
  //   id: 'isActive',
  //   label: 'Active',
  // },
  {
    id: 'loginAt',
    label: 'LAST LOGIN',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
]
